import { BackgroundColor } from "../../components/atoms/SubLayout";
import enhanceHomePage from "../../hocs/enhanceHomePage";
import { HistoryPage } from "./HistoryPage";
import { ListPage } from "./ListPage";
import { NewPage } from "./NewPage";

export const MultiSectionBatchesUploadDrillPage = enhanceHomePage(NewPage, {
  title: "校舎横断操作",
  backgroundColor: BackgroundColor.Gray,
});

export const MultiSectionBatchesUploadDrillListPage = enhanceHomePage(
  ListPage,
  {
    title: "校舎横断操作",
    backgroundColor: BackgroundColor.Gray,
  },
);

export const MultiSectionBatchesUploadDrillHistoryPage = enhanceHomePage(
  HistoryPage,
  {
    title: "校舎横断操作",
    backgroundColor: BackgroundColor.Gray,
  },
);
